<template>
  <article>
    <activity-stage :customRootContainerClass="'write-about-it'">
      <template slot="instructions">
        <slot name="instructions"></slot>
      </template>
      <div class="left-image-paragraph" slot="content">
        <figure>
          <img
            :alt="currentRound?.contentImage?.image.description"
            :src="currentRound?.contentImage?.image.src ?? ''"
          />
        </figure>
        <text-display-list :text-size="textSize">
          <li :class="{ title: true, isMobile }" v-if="currentRound.title">
            <h2>{{ currentRound.title }}</h2>
          </li>
          <li class="li-elem" v-for="(step, index) of currentRound.steps" :key="step.answer">
            <blinking-cursor-text :text="step.answer" :text-step="index"> </blinking-cursor-text>
          </li>
        </text-display-list>
      </div>
    </activity-stage>
    <slot name="keyboard"></slot>
  </article>
</template>

<script>
import { TimelineLite } from 'gsap';
import TypingActivityHelper from 'mixins/TypingActivityHelper';
import ActivityManager from 'mixins/ActivityManager';
import ErrorLogger from 'mixins/ErrorLogger';

import ActivityStage from 'components/activity/ActivityStage.vue';
import BlinkingCursorText from 'components/text-displays/BlinkingCursorText.vue';
import TextDisplayList from 'components/text-displays/TextDisplayList.vue';

export default {
  components: {
    ActivityStage,
    BlinkingCursorText,
    TextDisplayList
  },

  mixins: [TypingActivityHelper, ActivityManager, ErrorLogger],

  data() {
    return {
      activityName: 'LeftImageParagraph'
    };
  },

  computed: {
    textSize() {
      return this.currentRound.textSize;
    }
  },
  methods: {
    async loadActivity() {
      this.createRounds();
      await this.loadImages();
    },

    async loadImages() {
      this.rounds.forEach(({ contentImage }) => {
        this.queueImage(contentImage.image.src);
      });

      return this.downloadImages();
    },

    startActivity() {
      const timeline = new TimelineLite();

      this.setupNewRound();
      this.enableKeyboard();
      this.errorLoggerStart();
      timeline.to('.activity-stage', 0.5, { opacity: 1 });
      this.$nextTick(this.setActivityContainerHeight);
    },

    handleCorrectKey(attempt) {
      this.sndType();
      this.incrementTypingIndex();

      this.captureKeyboardAttemptSegment(attempt, this.isEndOfCurrentSentence);

      if (this.isEndOfCurrentSentence) {
        this.handleStepEnd();
      }

      if (this.isEndOfRound) {
        this.handleRoundEnd();
      }
    },

    handleStepEnd() {
      this.sndBell();
      this.finishStep();
    },

    finishStep() {
      this.completeStep();
      this.setCurrentStep();
    },

    handleRoundEnd() {
      const timeline = new TimelineLite();

      if (this.isEndOfActivity) {
        timeline.delay(1).call(this.completeActivity);
      } else {
        timeline
          .delay(1)
          .to('.activity-stage', 0.5, { opacity: 0 })
          .call(this.setupNewRound)
          .call(this.$nextTick, [() => timeline.to('.activity-stage', 0.5, { opacity: 1 })]);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.left-image-paragraph {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0px 3.5% 5% 3.5%;
  padding-top: 15px;

  @media (max-width: 863px) {
    flex-direction: column;
  }

  .title {
    &.isMobile {
      padding-right: 63px;
    }
  }

  .title,
  .li-elem {
    margin-bottom: 15px;
  }

  figure {
    display: block;
    margin: 30px 15px 0 0;
    padding: 0;
    text-align: center;
    width: 30%;

    img {
      width: 90%;
    }
  }

  ul {
    flex: 1;
    list-style: none;
    align-self: flex-start;
    padding: 0;

    li {
      p {
        text-align: justify;
        font-size: 20px;

        @media screen and (max-height: 768px) {
          margin-right: 30px;
          font-size: 16px;
        }
      }
    }
    .title {
      h2 {
        font-size: 25px;
        font-weight: bold;
        margin: 0px;
      }
    }
  }
}

.chrome-os,
.tablet {
  .left-image-paragraph {
    figure {
      width: 20%;
    }
  }
}
</style>
